<template>
<div class="col-6 col-sm-4" v-bind:class="{ 'kyano-card-small': data.isSmallClass}">
  <v-dialog v-model="dialog" max-width="500" content-class="elevation-0 rounded-xl">
    <template v-slot:activator="{ on, attrs }">
      <div
      class="kyano-business-card rounded-lg mb-2 kyano-business-card-profile-component-new rounded-xl"
        v-bind="attrs"
        v-on="on"    
      >
 
        <div class="kyano-card-content text-center">
          <v-icon color="secondary">fal fa-plus</v-icon>
          <span v-text="'Voeg businesscard toe'"></span>
        </div>
      </div>
    </template>
    <v-card
      elevation="0"
      class="h-100 py-5 px-2 pa-md-10 rounded-xl"
      color="white align-center"
    >
    <div class="d-flex">
      <v-btn
        color="primary"
        class="position-absolute"
        icon
        text
        @click="dialog = false"
      >
        <v-icon color="secondary">fal fa-times</v-icon></v-btn
      >
      <v-img
        class="m-auto mb-3"
        max-width="165"
        max-height="31"
        src="../assets/kyano-cards-logo-dark.svg"
      ></v-img>
</div>
      <v-stepper v-model="e1" elevation="0" class="elevation-0">
        <v-stepper-items>
          <v-stepper-content step="1">
            <h4
              v-text="'Nieuwe businesscard'"
              color="primary"
              class="
                headline
                font-weight-bold
                text-center
                mx-auto
                d-block
                text-primary
              "
            ></h4>
            <p class="text-center">
              Bestel een nieuwe fysieke card of registeer je nieuwe card
            </p>
            <v-img
              class="m-auto mb-3"
              max-width="300"
              max-height="500"
              src="../assets/kyano-card-illustration-people.svg"
            ></v-img>

            <v-spacer class="my-10"></v-spacer>
            <v-btn
              color="secondary"
              class="mb-3"
              large
              block
              elevation="0"
              @click="e1 = 2"
            >
              Registreren
            </v-btn>
            <v-btn color="bg_light" large block elevation="0" href="">
              Nieuwe card bestellen
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-subheader
              v-text="'Wat is je pasnummer?'"
              color="primary"
              class="headline font-weight-bold text-left pa-0 ma-0 text-primary"
            ></v-subheader>
            <p class="text-left">Dit is te vinden op de voorkant van je pas.</p>

            <v-text-field
              label="Pasnummer"
              :rules="[rules.required]"
              outlined
            ></v-text-field>

            <v-btn color="secondary" large block elevation="0" @click="e1 = 3">
              Volgende
            </v-btn>

            <v-btn
              class="mt-3"
              small
              color="primary"
              dark
              text
              append
              @click="e1 = 1"
            >
              <v-icon color="primary">mdi-arrow-left</v-icon> Vorige stap
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-subheader
              v-text="'Kies je profiel'"
              color="primary"
              class="headline font-weight-bold text-left pa-0 ma-0 text-primary"
            ></v-subheader>
            <p class="text-left">
              Selecteer een bestaande profiel of maak een nieuwe aan.
            </p>

            <ProfileToggle v-for="data in data" :key="data.id" :data="data" />
            <v-btn large block color="primary" elevation="0" class="mb-3"
              >Profiel aanmaken</v-btn
            >

            <v-btn
              color="secondary"
              large
              block
              elevation="0"
              @click="dialog = false"
            >
              Mijn card activeren
            </v-btn>
            <v-btn
              class="mt-3"
              small
              color="primary"
              dark
              text
              append
              @click="e1 = 2"
            >
              <v-icon color="primary">mdi-arrow-left</v-icon> Vorige stap
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
      </div>
</template>
<script>

import ProfileToggle from "./ProfileToggle.vue";
export default {
  components: { ProfileToggle },
  props: {
    data: Array,
    profile: Object,
  },
  data: () => ({
    e1: 1,
    dialog: false,
    rules: {
      required: (value) => !!value || "Verplicht.",
      min: (v) => v.length >= 6 || "Min 6 getallen",
    },
  }),
};
</script>

<style>

.kyano-dialog .v-dialog{
  border-radius: 20px!important;
}
.kyano-business-card-profile-component-new {
  width: 375px;
  max-width: 100%;
position: relative;
  height: 200px;
  display: block;
  text-decoration: none;
  border-radius: 15px;
  transition: 0.2s all ease-in-out;
  background: #34c75915;
  position: relative!important;
  padding: 20px!important;  
  overflow: hidden!important;
  max-width: 100%!important;
  margin: auto;
  
}
.kyano-business-card-profile-component-new:hover {
  background: #34c75925;
}
.kyano-business-card-profile-component-new .kyano-card-content {
  text-align: center;
  color: #34c759;
  transform: translateY(-50%);
  top: 50%;
  position: relative;
}
.kyano-business-card-profile-component-new .kyano-card-content .v-icon {
  font-size: 50px;
  text-align: center;
  display: block;
}

.position-absolute {
  position: absolute;
}
@media (max-width: 575.98px) {
  .kyano-business-card-profile-component-new {
    height: 120px;
  }
  .kyano-business-card-profile-component-new .kyano-card-content .v-icon {
    font-size: 25px;
  }
}
</style>
